import type { TFunction } from 'i18next';
import {
  formatKeyDateValues,
  getKeyDateTypeFromEventCode,
} from '../helpers/purchase-order-activity-text';
import type { PurchaseOrderActivityItem } from '../types/purchase-order-activity-item';

type PurchaseOrderActivityKeyDatesProps = {
  activity: PurchaseOrderActivityItem;
  locale: string;
  t: TFunction<'purchaseOrder'>;
};

export function PurchaseOrderActivityKeyDates({
  activity,
  locale,
  t,
}: PurchaseOrderActivityKeyDatesProps) {
  const keyDateType = getKeyDateTypeFromEventCode(activity.eventCode, t);
  const { oldValue, newValue, hasOldValue, hasNewValue, isDeletedValue } =
    formatKeyDateValues(activity, locale);

  return (
    <>
      <span className='font-semibold'>
        {t(
          isDeletedValue
            ? 'activity.keyDatesDeletedLabel'
            : hasOldValue
              ? 'activity.keyDatesLabel'
              : 'activity.keyDatesNewLabel',
          { keyDate: keyDateType },
        )}
      </span>
      {isDeletedValue ? (
        <>
          <span className='text-muted-foreground'>→</span>
          <span className='font-semibold'>{oldValue}</span>
        </>
      ) : hasOldValue ? (
        <>
          <span className='font-semibold'>{oldValue}</span>
          <span className='text-muted-foreground'>→</span>
        </>
      ) : null}
      {hasNewValue ? <span className='font-semibold'>{newValue}</span> : null}
    </>
  );
}
